<template>
  <div>
    <Toast/>
    <loader-container :active="loaderCount > 0 && showLoaderForRoute"/>

    <div id="nav">
      <navbar></navbar>
    </div>

    <confirmation-modal></confirmation-modal>
    <router-view :key="$route.path"/>

    <div id="footer">
      <footer-nav></footer-nav>
    </div>
  </div>
</template>

<style lang="less">
#app {
  font-family:
    Aino,
    -apple-system,
    system-ui,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
}

#brand {
  margin-right: 42px;
}
</style>
<script setup>
import Navbar from "@/views/components/nav/Navbar.vue";
import FooterNav from "@/views/components/nav/Footer.vue";
import confirmationModal from "@/views/components/modals/confirmationModal.vue";
import {computed, onMounted, onUnmounted, ref} from "vue";
import {injectAuth, injectAxios} from "@/util/inject";
import {AuthMethod} from "@/model/auth-method.js";
import LoaderContainer from "@/components/LoaderContainer.vue";
import {useRoute} from "vue-router";
import {RouteName} from "@/router/index.js";
import Toast from "primevue/toast";

const axios = injectAxios();
const auth = injectAuth();
const route = useRoute();
const timeoutRef = ref(0);
const loaderCount = ref(0);

onMounted(() => {
  interceptHttpForLoader();
  setRefreshTokenTimeout();
});

onUnmounted(() => {
  if (timeoutRef.value) {
    clearTimeout(timeoutRef.value);
  }
});

const setRefreshTokenTimeout = () => {
  timeoutRef.value = setTimeout(async () => {
    const buffer = 60 * 1000;
    const validAfter = Date.now() + buffer;

    if (auth.isAuthenticated() && !auth.isTokenValidAt(validAfter) && auth.getAuthMethod() === AuthMethod.UAA) {
      try {
        await auth.refreshToken();
      } catch (err) {
        auth.clearContext();
        console.error(`Refresh token: ${err}`);
      }
    }

    setRefreshTokenTimeout();
  }, 5000);
};

const showLoaderForRoute = computed(() => {
  return ![RouteName.Home, RouteName.MovingToEstonia, RouteName.Programme, RouteName.Adaptation].includes(route.name);
});

const interceptHttpForLoader = () => {
  const disabledUrls = new Set(["/account/email-confirmed"]);

  const addLoader = (url) => {
    if (!disabledUrls.has(url)) {
      loaderCount.value++;
    }
  };

  const removeLoader = (url) => {
    if (!disabledUrls.has(url)) {
      setTimeout(() => loaderCount.value--, 50); // Small timeout to avoid blinking loader due to await between API calls
    }
  };

  axios.interceptors.request.use((config) => {
    addLoader(config.url);
    return config;
  });

  axios.interceptors.response.use(
      (data) => {
        removeLoader(data.config.url);
        return data;
      },
      async (err) => {
        removeLoader(err.config.url);
        throw err;
      }
  );
};
</script>
